import { useMemo } from "react";
import { creativeLibraryApi } from "@/lib/api/creative-library";
import { organizationsApi } from "@/lib/api";
import type { ShareSettingsAdapter } from "@/components/sharing/ShareSettingsTypes";
export function useCreativeShareAdapter(
  token: string | null,
  organizationToken?: string | null,
) {
  return useMemo<ShareSettingsAdapter | null>(() => {
    if (!token || !organizationToken) return null;
    const unsupported = async (): Promise<never> => {
      throw new Error(
        "Public sharing is not available for Creative references",
      );
    };
    return {
      loadSharingData: async () => {
        const data = await creativeLibraryApi.sharing(token);
        return {
          sharingMode: data.sharingMode,
          collaborators: data.collaborators.map((person) => ({
            id: person.userToken,
            userId: person.userToken,
            role: "collaborator",
            user: { name: person.name, email: person.email },
          })),
          guests: [],
        };
      },
      loadShareStatus: async () => ({ isPublic: false, shareUrl: null }),
      loadOrgMembers: () => organizationsApi.getMembers(organizationToken),
      setSharingMode: async (mode) => {
        await creativeLibraryApi.setSharing(token, mode);
      },
      addCollaborator: async (userToken) => {
        await creativeLibraryApi.addCollaborator(token, userToken);
      },
      removeCollaborator: async (userToken) => {
        await creativeLibraryApi.removeCollaborator(token, userToken);
      },
      addGuest: unsupported,
      removeGuest: unsupported,
      enableSharing: unsupported,
      disableSharing: unsupported,
    };
  }, [token, organizationToken]);
}
